<template>
<div style="height: 100%;">
	<iframe :src="url" frameborder="0" width="100%" height="100%"></iframe>
</div>
</template>

<script>
export default{
	name:"xkw",
	data() {
		return {
			url:""
		}
	},
	created(){
		this.url = "http://47.109.80.27:7000/xkw?token="+sessionStorage.getItem("token")
	}
}
</script>

<style>
</style>
